// extracted by mini-css-extract-plugin
export var container = "layout-module--container--RoCXy";
export var heading = "layout-module--heading--3ayl9";
export var navLinks = "layout-module--nav-links--EJs56";
export var navLinkItem = "layout-module--nav-link-item--ax3XQ";
export var navLinkText = "layout-module--nav-link-text--emEAz";